// GRID
export const ROW = 'row';
export const ROW_REVERSE = 'row-reverse';
export const FORM_ROW = 'form-row';
export const COL = 'col';
export const COL_12 = 'col-12';
export const COL_6 = 'col-6';
export const COL_4 = 'col-4';
export const COL_3 = 'col-3';
export const COL_MD = 'col-md';
export const COL_LG = 'col-lg';
export const COL_XL = 'col-xl';
export const COL_AUTO = 'col-auto';

// UTILITIES
export const TEXT_LEFT = 'text-left';
export const TEXT_RIGHT = 'text-right';
export const TEXT_START = 'text-start';
export const TEXT_END = 'text-end';
export const TEXT_LG = 'text-lg';
export const TEXT_BOLD = 'text-bold';
export const TEXT_MEDIUM = 'text-medium';
export const TEXT_NOWRAP = 'text-nowrap';
export const FONT_ITALIC = 'font-italic';
export const FONT_WEIGHT_REGULAR = 'font-weight-regular';
export const D_NONE = 'd-none';
export const TEXT_DECORATION_UNDERLINE = 'text-decoration-underline';
export const BORDER_OPACITY = 'border-opacity';
